import { ApiBase } from 'api/api'
import { makeGetRequest } from 'api/fetchCalls'

import {
  AnalyticsMethodType,
  FormAnalyticsParams,
  FormAnalyticsResponse,
} from '@/domain/model/form-analytics'

export const loadAnalyticsById = async <T extends AnalyticsMethodType>(
  params: Partial<FormAnalyticsParams>
): Promise<FormAnalyticsResponse<T>> => {
  const response = await makeGetRequest(
    ApiBase + '/analytics/responses/metrics',
    {
      params,
    }
  )

  return response
}
